export function nutritionist(state) {
  return state.user.nutritionist
}
export function getUser(state) {
  if (state.user !== null) {
    return state.user.username
  } else {
    return null
  }
}
export function hasPermission(){
  return localStorage.getItem('loggedin');
}

export function getLanguage(state) {
  if (state.language !== null) {
    return state.language
  } else {
    return 'en'
  }
}

